import axios from 'axios'
import { Notify } from 'vant'
function searchParam(params) {
  var href = window.location.href
  var p = href.split('?')
  var result = null
  for (var i = 0; i < p.length; i++) {
    var s = p[i].split('&')
    for (var j = 0; j < s.length; j++) {
      if (s[j].split('=')[0] === params) {
        result = s[j].split('=')[1]
      }
    }
  }
  return result
}
// var iteration = 0 // 防止401时 弹出多个提示框
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_URL,
  timeout: 15000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    Notify({ type: 'danger', message: data.message })
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  config.headers['Accept'] = 'application/prs.assessment.v1+json'
  config.headers['Authorization'] = decodeURI(searchParam('token'))
  config.headers['institution'] = decodeURI(searchParam('institution'))
  // const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers['Access-Token'] = token
  // }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

export default request
